import _slicedToArray from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import React, { useState } from 'react';
// import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { useMutation } from '@apollo/client';
import Button from '@atoms/Button';
import Snackbar from '@molecules/Snackbar';
import { useTranslation } from '@app/config/i18n';
import { REQUEST_VERFICATION } from '@app/apollo/mutations';
import { Alert } from './style';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var VerficationAlert = function VerficationAlert() {
  var _useTranslation = useTranslation('common'),
    t = _useTranslation.t;
  var _useState = useState(false),
    open = _useState[0],
    setOpen = _useState[1];
  var _useMutation = useMutation(REQUEST_VERFICATION, {
      onCompleted: function onCompleted(data) {
        if (data) {
          setOpen(true);
        }
      }
    }),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    requestVerfication = _useMutation2[0],
    _useMutation2$ = _useMutation2[1],
    mutationLoading = _useMutation2$.loading,
    mutationError = _useMutation2$.error,
    mutationData = _useMutation2$.data;
  var requestVerficationHandler = function requestVerficationHandler() {
    requestVerfication();
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Snackbar, {
      type: "error",
      open: !!mutationError,
      message: /*#__PURE__*/_jsx("div", {
        children: t('sorry.error')
      })
    }), /*#__PURE__*/_jsx(Snackbar, {
      type: "loading",
      open: mutationLoading,
      message: /*#__PURE__*/_jsxs("div", {
        children: [t('loading'), " "]
      })
    }), /*#__PURE__*/_jsx(Snackbar, {
      type: "success",
      open: open,
      onClose: function onClose() {
        return setOpen(false);
      },
      message: /*#__PURE__*/_jsx("div", {
        children: t('success')
      })
    }), /*#__PURE__*/_jsxs(Alert, {
      severity: "warning",
      children: [/*#__PURE__*/_jsxs(Alert.AlertTitle, {
        children: [t('alert.type.warning'), ": ", t('alert.not_verified.title')]
      }), /*#__PURE__*/_jsxs(Grid, {
        container: true,
        direction: "row",
        alignItems: "baseline",
        children: [t('alert.not_verified.body'), /*#__PURE__*/_jsxs(Button, {
          variant: "text",
          onClick: requestVerficationHandler,
          disabled: mutationLoading,
          children: [' ', t('alert.not_verified.resend')]
        })]
      })]
    })]
  });
};
export default VerficationAlert;